import SignUpHeader from '../SignUpPage/SignUpHeader.js';

import '../../css/signup_page.css'
import { VectorIcon } from '../SignUpPage/VectorIcon.tsx';
import { VectorIcon1 } from '../SignUpPage/VectorIcon1.tsx';
import ForgotPasswordForm from './ForgotPasswordForm.js';


function ForgotPasswordPage() {
  return (
    <div className="w-full signup-parent-div">
      <div className="fixed top-0 left-0 w-full h-[102.91px] bg-white shadow-[0_2px_15px_rgba(0,0,0,0.15)] z-50">
        <SignUpHeader />
      </div>

      <div className="min-h-screen pt-[102.91px] flex items-center justify-center relative px-4">

        <div className="relative w-full max-w-screen-2xl flex justify-center">

          <div className="hidden lg:block absolute -top-20 -left-20 w-64 h-64 animate-float-slow pointer-events-none">
            <VectorIcon1 className="w-full h-full" />
          </div>

          <div
            className="
          w-full
          max-w-sm
          sm:max-w-md
          md:max-w-lg
          lg:max-w-xl
          xl:max-w-2xl
          2xl:max-w-3xl
          px-8
          py-8
          bg-white
          rounded-xl
          shadow-[0_0_20px_rgba(0,0,0,0.08)]
          z-10
        "
          >
            <ForgotPasswordForm />
          </div>

          <div className="hidden lg:block absolute -bottom-20 -right-20 w-48 h-48 animate-float-fast pointer-events-none">
            <VectorIcon className="w-full h-full" />
          </div>

        </div>
      </div>
    </div>

  );
}

export default ForgotPasswordPage;